import { apiSlice } from '@api'

export interface AssetValidationError {
  AssetId: string
  Errors: string[]
}

export interface AssetValidationResult {
  IsValid: boolean
  TotalErrors: number
  Errors: AssetValidationError[]
}

export const importEndpoints = apiSlice.injectEndpoints({
  endpoints: build => ({
    importAll: build.mutation<void, FormData>({
      query: (files) => ({
        url: '/Import/ImportAll',
        method: 'POST',
        body: files,
      }),
      invalidatesTags: ['Asset', 'company', 'segment', 'vendor', 'folder', 'task', 'insurance', 'maintenance', 'glPost', 'depreciation'],
    }),
    validateAssets: build.mutation<AssetValidationResult, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/Asset/ValidateAssets',
          method: 'POST',
          body: file,
        }
      },
    }),
    importGLPosts: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/GLPost/ImportGLPost',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['glPost'],
    }),
    importAssets: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/Asset/ImportAssets',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['Asset', 'dashboard'],
    }),
    importCompanies: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/AssetCompanies/ImportAssetCompanies',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['company'],
    }),
    importSegments: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/Segment/ImportSegment',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['segment'],
    }),
    importCategories: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/Deprecs/ImportDeprecs',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['depreciation'],
    }),
    importVendors: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/Vendor/ImportVendor',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['vendor'],
    }),
    importFolders: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/FldrMaster/ImportFolder',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['folder'],
    }),
    importTasks: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/Other/ImportOther',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['task'],
    }),
    importInsurance: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/Insurance/ImportInsurance',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['insurance'],
    }),
    importMaintenance: build.mutation<void, { file: FormData; mapping: unknown }>({
      query: ({ file, mapping }) => {
        file.append('mapping', JSON.stringify(mapping))
        return {
          url: '/Maintenance/ImportMaintenance',
          method: 'POST',
          body: file,
        }
      },
      invalidatesTags: ['maintenance'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useImportAllMutation,
  useImportGLPostsMutation,
  useImportAssetsMutation,
  useValidateAssetsMutation,
  useImportCompaniesMutation,
  useImportSegmentsMutation,
  useImportCategoriesMutation,
  useImportVendorsMutation,
  useImportFoldersMutation,
  useImportTasksMutation,
  useImportInsuranceMutation,
  useImportMaintenanceMutation,
} = importEndpoints
